/* eslint-disable react-hooks/exhaustive-deps */
import {
    AssignmentReturnOutlined,
    CalculateOutlined,
    CheckCircle,
    Clear,
    Delete,
    Download,
    Edit,
    ReplayOutlined,
    Search,
    ArrowBack,
    UndoOutlined,
    WarningAmberOutlined
} from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Tooltip, Typography } from "@mui/material";
import {
    GridActionsCellItem,
    GridRowId,
    GridRowModel,
    GridRowParams,
    GridRowSelectionModel,
    GridSortDirection,
    GridSortModel,
} from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";
import { format, parse } from "date-fns";
import { makeStyles } from "@mui/styles";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
import DataPicker from "../../../components/hookForms/datePicker";
import DataTable from "../../../components/dataTable";
import DatePickerMui from "../../../components/hookForms/datePicker";
import DialogApproveAll from "./modal/dialogApproveAll";
import DialogApproveById from "./modal/dialogApproveById";
import DialogCalculatedValues from "./modal/dialogCalculatedValues";
import DialogConfirm from "../../../components/confirmationDialog";
import DialogEdit from "./modal/dialogEdit";
import DialogInfo from "./modal/dialogInfo";
import DialogRecalculate from "./modal/dialogRecalculate";
import DialogReopen from "./modal/dialogReopen";
import DialogReverterReaberturaIndevida from "./modal/dialogReverterReaberturaIndevida";
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import messages from "../../../utils/messages";
import { s3download } from "../../../utils/s3";
import serviceFaturaInstalacao from "../../../services/serviceFaturaInstalacao";
import { useAuth } from "../../../context/global";
import { Divider } from "./styles";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import serviceUsina from "@/services/serviceUsina";
import serviceParametrizacao from "../../../services/serviceParametrizacao";
import DialogAlterStatusAll from "./modal/dialogAlterStatusAll";

const FaturaInstalacao = (props: any) => {
    const { setTitlePage } = useAuth();
    const history = useHistory();
    const [showBackOptions, setShowBackOptions] = useState(false);

    const filterOld = props?.location?.state?.filterOld || "";
    const rotaAnterior = props?.location?.state?.rotaAnterior || "";
    const { handleGetDataUser } = useAuth();
    const user = handleGetDataUser();
    const isAdmin = user.perfil === "Admin";
    const statusPermitidos = ["Aprovando", "Aprovada","Aguardando"];


    useEffect(() => {
        setTitlePage("Faturamento - Faturas de Instalações");
    }, [setTitlePage]);

    const [rowCount, setRowCount] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState(null);
    const [page, setPage] = useState(0);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [aprovarLoteDisabled, setAprovarLoteDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [approveAll, setApproveAll] = useState(false);
    const [approveById, setApproveById] = useState(false);
    const [reopen, setReopen] = useState(false);
    const [reverterReaberturaIndevida, setReverterReaberturaIndevida] = useState(false);
    const [habilitarAlteracaoManual, setHabilitarAlteracaoManual] = useState<boolean>(false);
    const [recalculate, setRecalculate] = useState(false);
    const [OpenAlterStatus, setOpenAlterStatus] = useState(false);
    const [recalculateId, setRecalculateId] = useState<any>();
    const [linesSelecteds, setLinesSelecteds] = useState<GridRowSelectionModel>([]);
    const [valueId, setValueId] = useState<any>();
    const classes = useStyles();
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [exclusionState, setExclusionState] = useState({ data: "", open: false });
    const [buttonSelected, setButtonSelected] = useState<any[]>(["Aberta"]);
    const [modalCalculatedValues, setModalCalculatedValues] = useState({ open: false, data: {} });
    const [dataMessages, setDataMessages] = useState<string[]>([]);
    const [infoModal, setInfoModal] = useState(false);
    const [editState, setEditState] = useState({
        open: false,
        id: "",
        energiaInjetada: "",
        energiaCompensada: "",
        consumo: "",
        saldoConsolidadoAnterior: "",
        saldoConsolidadoAtual: "",
        saldoConsolidadoDiferenca: "",
        disponibilidadeKWH: "",
        valorFaturaConcessionaria: "",
        dataVencimentoConcessionaria: "",
        energiaPrevista: "",
        saldoAlsolAnterior: "",
        saldoConcessionariaAnterior: "",
        saldoOutrosAnterior: "",
        bonificacaoDinheiro: "",
        bonificacaoKWH: "",
        acrescimoDinheiro: "",
        acrescimoKWH: "",
        saldoAlsolAtual: "",
        saldoConcessionariaAtual: "",
        saldoOutrosAtual: "",
        saldoAlsolDiferenca: "",
        saldoConcessionariaDiferenca: "",
        saldoOutrosDiferenca: "",
        creditosFaturados: "",
        kwhTotal: "",
        injecaoTotal: "",
        tarifaCobrada: "",
        precoTotal: "",
        totalPagar: "",
        numeroInstalacao: "",
        nomeUsina: "",
        injecaoAlsol: "",
        creditosMes: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            cicloFaturamento: null,
            usinaID: "",
            numeroInstalacao: "",
            dataVencimentoInicial: null,
            dataVencimentoFinal: null,
            statusFaturaInstalacao: "Aberta",
            corFaturamento: "",
            concessionariaID: "",
            codigoExterno: "",
            lancamentos: "",
            regraFatura: "",
            faturaClienteID: 0, //Vêm por parâmetro quando tela acionada via "instalações de clientes"
            clienteID: 0, //vem por parâmetro quando tela acionada via tela "Clientes"
        },
    });


    const handleClickOpenAlterstatus = () => {
        setOpenAlterStatus(true);
    };
    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                minWidth: 280,
                flex: 1,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Valores Calculados">
                                <CalculateOutlined />
                            </Tooltip>
                        }
                        label="Valores Calculados"
                        onClick={() => {
                            calculatedValues(params.row);
                        }}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Download">
                                <Download />
                            </Tooltip>
                        }
                        label="Baixar"
                        onClick={() => {
                            const bucket = process.env.REACT_APP_S3_BUCKET_FATURAS_INSTALACAO || "";
                            s3download(bucket, `${params.row.nomeUsina}/${params.id.toString()}.pdf`);
                        }}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Aprovar">
                                <CheckCircle />
                            </Tooltip>
                        }
                        label="Aprovar"
                        onClick={() => {
                            handleApproveById(params.id, params.row.numeroInstalacao, params.row.cicloFaturamento);
                        }}
                        disabled={params.row.statusFaturaInstalacao !== "Aberta" || aprovarLoteDisabled}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Recalcular">
                                <ReplayOutlined />
                            </Tooltip>
                        }
                        label="Recalcular"
                        onClick={() => handleRecalculate(params.row)}
                        disabled={params.row.statusFaturaInstalacao !== "Aberta"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                energiaInjetada: params.row.energiaInjetada,
                                energiaCompensada: params.row.energiaCompensada,
                                consumo: params.row.consumo,
                                saldoConsolidadoAnterior: params.row.saldoConsolidadoAnterior,
                                saldoConsolidadoAtual: params.row.saldoConsolidadoAtual,
                                saldoConsolidadoDiferenca: params.row.saldoConsolidadoDiferenca,
                                disponibilidadeKWH: params.row.disponibilidadeKWH,
                                valorFaturaConcessionaria: params.row.valorFaturaConcessionaria,
                                dataVencimentoConcessionaria: params.row.dataVencimentoConcessionaria,
                                energiaPrevista: params.row.energiaPrevista,
                                saldoAlsolAnterior: params.row.saldoAlsolAnterior,
                                saldoConcessionariaAnterior: params.row.saldoConcessionariaAnterior,
                                saldoOutrosAnterior: params.row.saldoOutrosAnterior,
                                bonificacaoDinheiro: params.row.bonificacaoDinheiro,
                                bonificacaoKWH: params.row.bonificacaoKWH,
                                acrescimoDinheiro: params.row.acrescimoDinheiro,
                                acrescimoKWH: params.row.acrescimoKWH,
                                saldoAlsolAtual: params.row.saldoAlsolAtual,
                                saldoConcessionariaAtual: params.row.saldoConcessionariaAtual,
                                saldoOutrosAtual: params.row.saldoOutrosAtual,
                                saldoAlsolDiferenca: params.row.saldoAlsolDiferenca,
                                saldoConcessionariaDiferenca: params.row.saldoConcessionariaDiferenca,
                                saldoOutrosDiferenca: params.row.saldoOutrosDiferenca,
                                creditosFaturados: params.row.creditosFaturados,
                                kwhTotal: params.row.kwhTotal,
                                injecaoTotal: params.row.injecaoTotal,
                                tarifaCobrada: params.row.tarifaCobrada,
                                precoTotal: params.row.precoTotal,
                                totalPagar: params.row.totalPagar,
                                nomeUsina: params.row.nomeUsina,
                                numeroInstalacao: params.row.numeroInstalacao,
                                injecaoAlsol: params.row.injecaoAlsol,
                                creditosMes: params.row.creditosMes,
                            })
                        }
                        disabled={params.row.statusFaturaInstalacao !== "Aberta"}
                    />,

                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Reabrir">
                                <AssignmentReturnOutlined />
                            </Tooltip>
                        }
                        label="Reabrir"
                        onClick={() =>
                            handleReopen(params.id, params.row.numeroInstalacao, params.row.cicloFaturamento)
                        }
                        disabled={
                            params.row.statusFaturaInstalacao === "Aberta" ||
                            params.row.statusFaturaInstalacao === "Aprovando"
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => setExclusionState({ data: params.id.toString(), open: true })}
                        disabled={params.row.statusFaturaInstalacao !== "Aberta"}
                    />,

                    ...(isAdmin && habilitarAlteracaoManual ? [
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Reverter Reabertura Indevida">
                                    <UndoOutlined />
                                </Tooltip>
                            }
                            label="Reverter Reabertura Indevida"
                            onClick={() =>
                                handleReverterReaberturaIndevida(params.id, params.row.numeroInstalacao, params.row.cicloFaturamento)
                            }
                            disabled={params.row.statusFaturaInstalacao !== "Aberta"}
                        />,
                    ] : []),

                ],
            },
        ],
        [filters, habilitarAlteracaoManual]
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "faturaInstalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                minWidth: 80,
                flex: 1,
            },
            {
                headerName: "Ciclo",
                field: "cicloFaturamento",
                type: "string",
                minWidth: 80,
                flex: 1,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                minWidth: 350,
                flex: 1,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                minWidth: 180,
                flex: 1,
            },
            {
                headerName: "Cota",
                field: "cotaKWH",
                type: "number",
                headerAlign: "left",
                minWidth: 120,
                flex: 1,
            },
            {
                headerName: "Qtd Injetada",
                field: "energiaInjetada",
                type: "number",
                headerAlign: "left",
                minWidth: 120,
                flex: 1,
            },
            {
                headerName: "Injeção cobrada",
                field: "creditosFaturados",
                type: "number",
                headerAlign: "left",
                minWidth: 150,
                flex: 1,
            },
            {
                headerName: "Valor fatura (R$)",
                field: "valorFatura",
                type: "number",
                headerAlign: "left",
                minWidth: 180,
                flex: 1,
            },
            {
                headerName: "Vencimento",
                field: "dataVencimentoConcessionaria",
                type: "date",
                minWidth: 150,
                flex: 1,
            },
            {
                headerName: "Status",
                field: "statusFaturaInstalacao",
                type: "string",
                minWidth: 100,
                flex: 1,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setUsinaData();
        setConcessionariaData();
        carregarParametroHabilitarAlteracaoManual();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const carregarParametroHabilitarAlteracaoManual = async () => {
        serviceParametrizacao
            .getWithFilter({ nomeParametro: "Controla reversão de reabertura", contexto: "Faturamento", habilitado: true, take: 1, currentPage: 1 })
            .then((result) => {
                const item = result?.data?.content?.[0];
                setHabilitarAlteracaoManual(item?.valor?.toLowerCase() === "ativo");
            })
            .catch(() => {
                setHabilitarAlteracaoManual(false);
            });
    };

    const statusOptions = [
        { label: "Aberta", value: "Aberta" },
        { label: "Aprovando", value: "Aprovando" },
        { label: "Aprovada", value: "Aprovada" },
        { label: "Aguardando", value: "Aguardando" },
        { label: "Publicada", value: "Publicada" },
    ];

    const coresOptions = [
        { label: "Amarelo", value: "Amarelo" },
        { label: "Azul", value: "Azul" },
        { label: "Branco", value: "Branco" },
        { label: "Cinza", value: "Cinza" },
        { label: "Laranja", value: "Laranja" },
        { label: "Marrom", value: "Marrom" },
        { label: "Roxo", value: "Roxo" },
        { label: "Verde", value: "Verde" },
        { label: "Vermelho", value: "Vermelho" },
    ];

    const handleApproveById = (id: any, numeroInstalacao: any, cicloFaturamento: any) => {
        setApproveById(true);
        setValueId({ id, numeroInstalacao, cicloFaturamento });
    };

    const handleReopen = (id: any, numeroInstalacao: any, cicloFaturamento: any) => {
        setReopen(true);
        setValueId({ id, numeroInstalacao, cicloFaturamento });
    };

    const handleReverterReaberturaIndevida = (id: any, numeroInstalacao: any, cicloFaturamento: any) => {
        setReverterReaberturaIndevida(true);
        setValueId({ id, numeroInstalacao, cicloFaturamento });
    };

    const handleRecalculate = (rowData: any) => {
        setRecalculate(true);
        setRecalculateId(rowData);
    };

    const getAllWithFilters = async (filters: any) => {
        setLoading(true);
        setData([]);

        if (!filters) {
            filters = { statusFaturaInstalacao: "Aberta" };
        }

        serviceFaturaInstalacao
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                if (result) {
                    setData(result?.data.content);
                    setRowCount(result?.data.numberOfElements);
                }
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            if (props && props.location && props.location.state) {
                getAllWithFilters(props.location.state);
                if (
                    !props.location.state.statusFaturaInstalacao ||
                    props.location.state.statusFaturaInstalacao.length <= 0
                ) {
                    setButtonSelected([]);
                }
            } else {
                getAllWithFilters(filters);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const lancamentosOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Sim", value: "Sim" },
        { label: "Não", value: "Não" },
    ];

    const regraFaturaOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Fatura de Concessionária", value: "Fatura de Concessionária" },
        { label: "Fatura Prevista Injetado", value: "Fatura Prevista Injetado" },
        { label: "Fatura Prevista Consumo", value: "Fatura Prevista Consumo" },
    ];

    const onClear = () => {
        setButtonSelected(["Aberta"]);
        reset({ faturaClienteID: 0, clienteID: 0, statusFaturaInstalacao: "Aberta" });
        setFilters(null);
        getAllWithFilters(null);
        setShowBackOptions(false);
    };

    const calculatedValues = (row: any) => {
        setModalCalculatedValues({ open: true, data: row });
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            faturaClienteID: 0,
            lancamentos: values.lancamentos === "Todos" ? "" : values.lancamentos,
            regraFatura: values.regraFatura === "Todos" ? "" : values.regraFatura,
            dataVencimentoInicial: values.dataVencimentoInicial
                ? format(values?.dataVencimentoInicial, "dd/MM/yyyy")
                : "",
            dataVencimentoFinal: values.dataVencimentoFinal ? format(values?.dataVencimentoFinal, "dd/MM/yyyy") : "",
            statusFaturaInstalacao: buttonSelected.join(","),
            cicloFaturamento: values.cicloFaturamento ? format(values.cicloFaturamento, "MM/yyyy") : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            reset(props.location.state);
            setFilters(props.location.state);
            getAllWithFilters(props.location.state);
            setShowBackOptions(true);
        }
    }, [props]);

    const handleDelete = async () => {
        serviceFaturaInstalacao
            .delete(exclusionState.data)
            .then((result) => {
                if (result) {
                    toast.success(messages.deleteSucess);
                }
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    const handleApproveMany = () => {
        setAprovarLoteDisabled(true);
        setLoading(true);

        const selecteds = data.filter((item) => linesSelecteds.includes(item.faturaInstalacaoID));

        let arrayMenssages: string[] = [];
        let listIds: number[] = [];

        if (selecteds.length > 0) {
            // eslint-disable-next-line array-callback-return
            selecteds.map((value) => {
                if (value.statusFaturaInstalacao === "Aberta") {
                    listIds.push(value.faturaInstalacaoID);
                } else {
                    arrayMenssages.push(
                        `A fatura de instalação para UC ${value.numeroInstalacao} - ID: ${value.faturaInstalacaoID} não pode ser aprovada.`
                    );
                }
            });
        }

        if (arrayMenssages.length > 0) {
            setDataMessages(arrayMenssages);
            setAprovarLoteDisabled(false);
            setLoading(false);
            return;
        }

        const newValues = {
            faturasIds: listIds.length >= 0 ? listIds.join(", ") : "",
        };

        serviceFaturaInstalacao
            .approveMany(newValues)
            .then((result) => {
                if (result) {
                    toast.info("A aprovação da(s) fatura(s) selecionada(s) será realizada, por favor aguarde.");
                }
            })
            .catch((err) => {
                toast.error("Ocorreu um erro e não foi possível aprovar as faturas selecionadas", err);
            })
            .finally(() => {
                setTimeout(() => {
                    getAllWithFilters(filters);
                }, 500);
                setAprovarLoteDisabled(false);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (dataMessages.length > 0) setInfoModal(true);
    }, [dataMessages]);

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            {showBackOptions && rotaAnterior && (
                                <Grid container spacing={2} display="flex" alignItems="left">
                                    <Grid item md={2}>
                                        <Button
                                            id="voltar"
                                            disableElevation
                                            variant="text"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<ArrowBack />}
                                            onClick={() => {
                                                history.push(rotaAnterior, {
                                                    ...filterOld,
                                                    cicloFaturamento:
                                                        filterOld.cicloFaturamento &&
                                                            filterOld.cicloFaturamento.length === 7
                                                            ? parse(
                                                                "01/" + filterOld.cicloFaturamento,
                                                                "dd/MM/yyyy",
                                                                new Date()
                                                            )
                                                            : filterOld.cicloFaturamento ?? "",
                                                    dataVencimento: filterOld.dataVencimento
                                                        ? filterOld.dataVencimento.length !== 10
                                                            ? filterOld.dataVencimento
                                                            : parse(filterOld.dataVencimento, "dd/MM/yyyy", new Date())
                                                        : "",
                                                });
                                            }}
                                        >
                                            Voltar
                                        </Button>
                                    </Grid>
                                    <Grid item md={10}>
                                        <Divider>
                                            {filterOld.codigoExternoCliente && (
                                                <div className="subTitle">{`Código Externo: ${filterOld.codigoExternoCliente}.`}</div>
                                            )}
                                            {filterOld.nomeCliente && (
                                                <div className="subTitle">{`Nome Cliente: ${filterOld.nomeCliente}.`}</div>
                                            )}
                                        </Divider>
                                    </Grid>
                                </Grid>
                            )}
                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item md={2}>
                                    <DatePickerMui
                                        id="cicloFaturamento"
                                        name="cicloFaturamento"
                                        label="Ciclo"
                                        format="MM/yyyy"
                                        view={["month", "year"]}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <AutoComplete
                                        id="regraFatura"
                                        name="regraFatura"
                                        label="Tipo de fatura"
                                        control={control}
                                        error={errors}
                                        options={regraFaturaOptions}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <InputNumber
                                        id="numeroInstalacao"
                                        name="numeroInstalacao"
                                        label="Instalação"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={15}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <AutoComplete
                                        id="lancamentos"
                                        name="lancamentos"
                                        label="Lançamentos"
                                        control={control}
                                        error={errors}
                                        options={lancamentosOptions}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <AutoComplete
                                        id="corFaturamento"
                                        name="corFaturamento"
                                        label="Trava"
                                        control={control}
                                        error={errors}
                                        options={coresOptions}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        id="aprovar"
                                        variant="contained"
                                        fullWidth
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<CheckCircle />}
                                        onClick={() => handleApproveMany()}
                                        disableElevation
                                        disabled={aprovarLoteDisabled || linesSelecteds.length <= 0}
                                    >
                                        Aprovar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item md={2}>
                                    <DataPicker
                                        id="dataVencimentoInicial"
                                        name="dataVencimentoInicial"
                                        label="Vencimento inicial"
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <DataPicker
                                        id="dataVencimentoFinal"
                                        name="dataVencimentoFinal"
                                        label="Vencimento final"
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <InputNumber
                                        id="codigoExterno"
                                        name="codigoExterno"
                                        label="Cod. Externo"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={10}
                                    />
                                </Grid>
                                <Grid item md={2} xs={12}>
                                    <AutoComplete
                                        id="concessionariaID"
                                        name="concessionariaID"
                                        label="Concessionária"
                                        options={concessionariaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <AutoComplete
                                        id="usinaID"
                                        name="usinaID"
                                        label="Nome da usina"
                                        options={usinaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        id="pesquisar"
                                        variant="contained"
                                        fullWidth
                                        color="warning"
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<Search />}
                                        type="submit"
                                        disabled={isLoading}
                                        disableElevation
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={10} sx={{ mt: 2 }}>
                                    <Typography variant="subtitle2" color="#5B5B5F">
                                        Status:
                                        {statusOptions.map((item, index) => {
                                            return (
                                                <Button
                                                    id={item.label.toLowerCase()}
                                                    key={index}
                                                    variant={
                                                        buttonSelected.includes(item.value) ? "contained" : "outlined"
                                                    }
                                                    color="warning"
                                                    size="small"
                                                    disableElevation
                                                    onClick={() => {
                                                        setButtonSelected((oldstate) => {
                                                            if (oldstate.includes(item.value)) {
                                                                return oldstate.filter((e) => e !== item.value);
                                                            } else {
                                                                return [...oldstate, item.value];
                                                            }
                                                        });
                                                    }}
                                                    style={{ margin: "0px 12px", minWidth: "150px", height: "33px" }}
                                                >
                                                    {item.label}
                                                </Button>
                                            );
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={2} display="flex" justifyContent="flex-start">
                                    <Button
                                        id="limpar"
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        variant="outlined"
                                        color="warning"
                                        startIcon={<Clear />}
                                        onClick={() => onClear()}
                                        disableElevation
                                        fullWidth
                                        size="small"
                                    >
                                        Limpar
                                    </Button>
                                </Grid>
                            </Grid>
                            {isAdmin && (
                                <Grid container spacing={2} sx={{ mt: 1 }} justifyContent="flex-end">
                                    <Grid item md={2}>
                                        <Button
                                            id="Alterar Status"
                                            variant="contained"
                                            startIcon={<WarningAmberOutlined />}
                                            onClick={handleClickOpenAlterstatus}
                                            disableElevation
                                            fullWidth
                                            disabled={
                                                aprovarLoteDisabled ||
                                                linesSelecteds.length <= 0 ||
                                                !buttonSelected.some(status => statusPermitidos.includes(status))
                                            }

                                        >
                                            Alterar Status
                                        </Button>
                                    </Grid>
                                </Grid>
                            )}
                        </form>
                    </Box>
                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.faturaInstalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            getRowClassName={(params: GridRowParams<GridRowModel>) => {
                                if (params.row.corFaturamento === "Amarelo") return classes.amarelo;
                                else if (params.row.corFaturamento === "Azul") return classes.azul;
                                else if (params.row.corFaturamento === "Branco") return classes.branco;
                                else if (params.row.corFaturamento === "Cinza") return classes.cinza;
                                else if (params.row.corFaturamento === "Laranja") return classes.laranja;
                                else if (params.row.corFaturamento === "Roxo") return classes.roxo;
                                else if (params.row.corFaturamento === "Verde") return classes.verde;
                                else if (params.row.corFaturamento === "Vermelho") return classes.vermelho;
                                else if (params.row.corFaturamento === "Marrom") return classes.marrom;
                            }}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                            checkboxSelection
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setLinesSelecteds(newSelectionModel);
                            }}
                            rowSelectionModel={linesSelecteds}
                        />
                    </Box>
                    {approveAll && (
                        <DialogApproveAll
                            open
                            onClose={() => setApproveAll(false)}
                            onSave={() => getAllWithFilters(filters)}
                        />
                    )}
                    {OpenAlterStatus && (
                        <DialogAlterStatusAll
                            open
                            onClose={() => setOpenAlterStatus(false)}
                            onSave={() => getAllWithFilters(filters)}
                            qtdeFatura={linesSelecteds.length}
                            statusSelecionado={statusOptions.filter(option => buttonSelected.includes(option.value))}
                            faturaIds={linesSelecteds}

                        />
                    )}
                    <DialogApproveById
                        open={approveById}
                        clearDataTable={() => {
                            getAllWithFilters(filters);
                        }}
                        closeParentModal={() => setModalCalculatedValues({ open: false, data: {} })}
                        idProp={valueId}
                        onClose={() => setApproveById(false)}
                    />
                    <DialogReopen
                        open={reopen}
                        idProp={valueId}
                        onClose={() => {
                            setReopen(false);
                            getAllWithFilters(filters);
                        }}
                        onCancel={() => {
                            setReopen(false);
                        }}
                    />
                    <DialogReverterReaberturaIndevida
                        open={reverterReaberturaIndevida}
                        idProp={valueId}
                        onClose={() => {
                            setReverterReaberturaIndevida(false);
                            getAllWithFilters(filters);
                        }}
                        onCancel={() => {
                            setReverterReaberturaIndevida(false);
                        }}
                    />
                    <DialogCalculatedValues
                        open={modalCalculatedValues.open}
                        data={modalCalculatedValues.data}
                        clearDataTable={() => getAllWithFilters(filters)}
                        onClose={() => setModalCalculatedValues({ open: false, data: {} })}
                    />
                    <DialogRecalculate
                        open={recalculate}
                        data={recalculateId}
                        onClose={() => setRecalculate(false)}
                        onSuccess={() => onSuccessAction()}
                    />
                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            energiaInjetada: editState.energiaInjetada,
                            energiaCompensada: editState.energiaCompensada,
                            consumo: editState.consumo,
                            saldoConsolidadoAnterior: editState.saldoConsolidadoAnterior,
                            saldoConsolidadoAtual: editState.saldoConsolidadoAtual,
                            saldoConsolidadoDiferenca: editState.saldoConsolidadoDiferenca,
                            disponibilidadeKWH: editState.disponibilidadeKWH,
                            valorFaturaConcessionaria: editState.valorFaturaConcessionaria,
                            dataVencimentoConcessionaria: editState.dataVencimentoConcessionaria,
                            energiaPrevista: editState.energiaPrevista,
                            saldoAlsolAnterior: editState.saldoAlsolAnterior,
                            saldoConcessionariaAnterior: editState.saldoConcessionariaAnterior,
                            saldoOutrosAnterior: editState.saldoOutrosAnterior,
                            bonificacaoDinheiro: editState.bonificacaoDinheiro,
                            bonificacaoKWH: editState.bonificacaoKWH,
                            acrescimoDinheiro: editState.acrescimoDinheiro,
                            acrescimoKWH: editState.acrescimoKWH,
                            saldoAlsolAtual: editState.saldoAlsolAtual,
                            saldoConcessionariaAtual: editState.saldoConcessionariaAtual,
                            saldoOutrosAtual: editState.saldoOutrosAtual,
                            saldoAlsolDiferenca: editState.saldoAlsolDiferenca,
                            saldoConcessionariaDiferenca: editState.saldoConcessionariaDiferenca,
                            saldoOutrosDiferenca: editState.saldoOutrosDiferenca,
                            creditosFaturados: editState.creditosFaturados,
                            kwhTotal: editState.kwhTotal,
                            injecaoTotal: editState.injecaoTotal,
                            tarifaCobrada: editState.tarifaCobrada,
                            precoTotal: editState.precoTotal,
                            totalPagar: editState.totalPagar,
                            nomeUsina: editState.nomeUsina,
                            numeroInstalacao: editState.numeroInstalacao,
                            injecaoAlsol: editState.injecaoAlsol,
                            creditosMes: editState.creditosMes,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                energiaInjetada: "",
                                energiaCompensada: "",
                                consumo: "",
                                saldoConsolidadoAnterior: "",
                                saldoConsolidadoAtual: "",
                                saldoConsolidadoDiferenca: "",
                                disponibilidadeKWH: "",
                                valorFaturaConcessionaria: "",
                                dataVencimentoConcessionaria: "",
                                energiaPrevista: "",
                                saldoAlsolAnterior: "",
                                saldoConcessionariaAnterior: "",
                                saldoOutrosAnterior: "",
                                bonificacaoDinheiro: "",
                                bonificacaoKWH: "",
                                acrescimoDinheiro: "",
                                acrescimoKWH: "",
                                saldoAlsolAtual: "",
                                saldoConcessionariaAtual: "",
                                saldoOutrosAtual: "",
                                saldoAlsolDiferenca: "",
                                saldoConcessionariaDiferenca: "",
                                saldoOutrosDiferenca: "",
                                creditosFaturados: "",
                                kwhTotal: "",
                                injecaoTotal: "",
                                tarifaCobrada: "",
                                precoTotal: "",
                                totalPagar: "",
                                numeroInstalacao: "",
                                nomeUsina: "",
                                injecaoAlsol: "",
                                creditosMes: "",
                            });
                        }}
                    />
                    <DialogConfirm
                        open={exclusionState?.open}
                        title={"Excluir"}
                        message={messages.deleteConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setExclusionState({ data: "", open: false })}
                        onCancel={() => setExclusionState({ data: "", open: false })}
                        onConfirm={() => {
                            setExclusionState({ data: "", open: false });
                            handleDelete();
                        }}
                    />
                </CardContent>
            </Card>
            {infoModal && (
                <DialogInfo
                    data={dataMessages}
                    onClose={() => {
                        setInfoModal(false);
                        setDataMessages([]);
                    }}
                />
            )}
        </Container>
    );
};

const useStyles = makeStyles({
    amarelo: {
        backgroundColor: "#FAF8B4",
        "&:hover": {
            backgroundColor: "#f4f066 !important",
        },
    },
    azul: {
        backgroundColor: "#D1E8F7",
        "&:hover": {
            backgroundColor: "#9bcded !important",
        },
    },
    branco: {
        backgroundColor: "#FFFFFF",
        "&:hover": {
            backgroundColor: "#e5e5e5 !important",
        },
    },
    cinza: {
        backgroundColor: "#D3D3D3",
        "&:hover": {
            backgroundColor: "#bababa !important",
        },
    },
    laranja: {
        backgroundColor: "#FACCA7",
        "&:hover": {
            backgroundColor: "#f6ab6e !important",
        },
    },
    roxo: {
        backgroundColor: "#EEBBFD",
        "&:hover": {
            backgroundColor: "#e188fb !important",
        },
    },
    verde: {
        backgroundColor: "#AAFFB2",
        "&:hover": {
            backgroundColor: "#7fff8b !important",
        },
    },
    vermelho: {
        backgroundColor: "#FFA0A3",
        "&:hover": {
            backgroundColor: "#ff6b6f !important",
        },
    },
    marrom: {
        backgroundColor: "#d9a672",
        "&:hover": {
            backgroundColor: "#ad845b !important",
        },
    },
});

export default FaturaInstalacao;
